"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteEventTypeBodyToJSON = exports.DeleteEventTypeBodyFromJSONTyped = exports.DeleteEventTypeBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function DeleteEventTypeBodyFromJSON(json) {
    return DeleteEventTypeBodyFromJSONTyped(json, false);
}
exports.DeleteEventTypeBodyFromJSON = DeleteEventTypeBodyFromJSON;
function DeleteEventTypeBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'deleteRawDataMappers': !(0, runtime_1.exists)(json, 'deleteRawDataMappers') ? undefined : json['deleteRawDataMappers'],
    };
}
exports.DeleteEventTypeBodyFromJSONTyped = DeleteEventTypeBodyFromJSONTyped;
function DeleteEventTypeBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'deleteRawDataMappers': value.deleteRawDataMappers,
    };
}
exports.DeleteEventTypeBodyToJSON = DeleteEventTypeBodyToJSON;
